export const DialogTitleStyles = { pb: '0.25rem', pt: '2rem', pl: '1.5rem' }
export const DialogContentColorHex = '#000000DE'
export const DialogActionsStyles = { pr: '24px', pb: '24px', pt: '28px' }
